import { render, staticRenderFns } from "./ShowLayout.vue?vue&type=template&id=51a63558&"
import script from "./ShowLayout.vue?vue&type=script&lang=js&"
export * from "./ShowLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports